import { getOsPreferredTheme } from './getOsPreferredTheme';
/**
 * Choose a theme based on the current theme key.
 */
export const getIsDarkModeFromThemeKey = (themeKey) => {
    switch (themeKey) {
        case 'DARK':
            return true;
        case 'LIGHT':
            return false;
        case 'AUTO':
        case undefined:
        // IMPORTANT:
        // Default to dark theme so we don't flash a bright background
        // to light-sensitive users.
        /* eslint-disable-next-line no-fallthrough */
        default: {
            /** User's preference for dark or light in the browser */
            const osDarkModePreferred = getOsPreferredTheme();
            return osDarkModePreferred === 'DARK';
        }
    }
};
